import React from 'react'
import "./index.css"
import {Card} from 'react-bootstrap'
// import {CardGroup} from 'react-bootstrap'

export default function Recipies(props) {
 const {recipie}=props;
  return (
    <>
    
    
  {
    recipie.map((ret)=>{
      return(
        <>
       
   
  <Card >
  <div className='card'>
  <Card.Img variant="top" id="im" src={ret.recipe.image}/> 
    <Card.Body>
      <Card.Title className='text1'> {ret.recipe.label}</Card.Title>
      <Card.Text  className='text2'>
        {ret.recipe.ingredientLines}
      </Card.Text>
    </Card.Body>
    </div>
  </Card>
  
        </>
     )
      })
  } 
    
    </>
    )
    }
  

            
         

         
             
         
    
  
